var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'activity-progress-bar': true,
      'has-activity-instructions': _vm.activityHasInstructions
    },
    attrs: {
      "aria-label": "activities completed",
      "role": "progressbar",
      "aria-valuemax": _vm.totalActivities,
      "aria-valuenow": _vm.currentActivity
    }
  }, [_c('div', {
    staticClass: "activity-progress-bar-background",
    style: {
      width: ((_vm.progressPercentage) + "%")
    }
  }), _c('div', {
    class: {
      'activity-progress-bar-content': true,
      'has-activity-instructions': _vm.activityHasInstructions
    }
  }, [_vm._v("\n    " + _vm._s(_vm.currentActivity) + " of " + _vm._s(_vm.totalActivities) + "\n  ")])]);
}
var staticRenderFns = []

export { render, staticRenderFns }